import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import './BankSelector.scss'
import { IGoCardlessBankItem } from 'interfaces/i-gocardless'

type IBankSelectorProps = {
	items: IGoCardlessBankItem[]
	selectedId?: string
	onSelect: (id: string) => void
}

const BankSelector: React.FC<IBankSelectorProps> = ({
	items,
	selectedId,
	onSelect,
}) => {
	const { t } = useTranslation()
	const [search, setSearch] = useState('')

	const filteredItems = items.filter((item) =>
		item.name.toLowerCase().includes(search.toLowerCase()),
	)

	return (
		<div className="bank-selector-container">
			<input
				type="text"
				placeholder={t('BankSearch')}
				value={search}
				onChange={(e) => setSearch(e.target.value)}
				className="bank-search"
			/>
			<div className="banks-list-container">
				{filteredItems.map((item) => {
					const isSelected = selectedId === item.id

					return (
						<div
							key={item.id}
							onClick={() => onSelect?.(item.id)}
							className={
								isSelected ? 'bank-item-selected' : 'bank-item'
							}>
							<img src={item.logo} alt={item.name} />

							<div>{item.name}</div>
						</div>
					)
				})}
				{filteredItems.length === 0 && <p>{t('BanksListEmpty')}</p>}
			</div>
		</div>
	)
}

export default BankSelector
